import type { AppRouteRecordRaw } from "../types/types";

import { RouteNames } from "@/app/router/types/names";
import { Permissions, PermissionGroups } from "@/shared/constants";

const categoryRoutes: AppRouteRecordRaw[] = [
  {
    path: "/category",
    name: "category-parent",
    redirect: "/category/analysis",
    meta: {
      menuIcon: "lucide:tags",
      menuTitle: "Category",
      isMenuParent: true,
      permissions: PermissionGroups.CATEGORY,
    },
    children: [
      {
        path: "analysis",
        name: RouteNames.CATEGORY,
        meta: {
          permissions: [Permissions.CATEGORY_ANALYSIS],
          filters: {
            show: ["brands"],
          },
          title: "Category Analysis",
          menuTitle: "Analysis",
          menuIcon: "lucide:shapes",
        },
        component: () => import("@/pages/Category/CategoryAnalytics.vue"),
      },
      {
        path: "competitor",
        name: RouteNames.COMPETITOR,
        meta: {
          permissions: [Permissions.COMPETITOR],
          filters: {
            show: ["brands"],
          },
          title: "Brand Competitors",
          menuTitle: "Brand Competitors",
          menuIcon: "lucide:git-compare",
        },
        component: () => import("@/pages/Category/CategoryBrandCompetitor.vue"),
      },
    ],
  },

];

export default categoryRoutes;
